import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultError } from '@/common/components/error/DefaultError';
import { logoutViaAuth0 } from '@/common/components/error/GlobalErrorBoundary';

interface AuthErrorProps {
  error?: Error;
  tryAgain?: () => void;
}

export const AuthError = ({ error, tryAgain }: AuthErrorProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      datadogRum.addError(error, {
        source: 'auth0',
        type: 'authentication-error',
        stack: error.stack,
        message: error.message,
      });
    }
  }, [error]);

  return (
    <DefaultError
      title={t(($) => $.common.errors.auth.title)}
      description={t(($) => $.common.errors.auth.description)}
      actions={[
        {
          label: t(($) => $.common.tryAgain),
          action: tryAgain ?? logoutViaAuth0,
        },
      ]}
    />
  );
};
